import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=06014a9d&scoped=true"
import script from "./teacherList.vue?vue&type=script&lang=js"
export * from "./teacherList.vue?vue&type=script&lang=js"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=06014a9d&prod&lang=scss&scoped=true"
import style1 from "./teacherList.vue?vue&type=style&index=1&id=06014a9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06014a9d",
  null
  
)

export default component.exports